import React from 'react';
import { useEffect } from 'react';
import { isNil, get } from 'lodash';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/LawyerFeeNote/messages';
import WarningCard from 'components/InvoiceFeeNoteDialog/WarningCard';
import { constructUrlInvoice } from 'containers/LawyerFeeNote/utils';
import { translate } from 'containers/services/translate';
import WarningCardSkeleton from 'components/InvoiceFeeNoteDialog/WarningCardSkeleton';

export interface invoiceDocumentInfoProps {
  intl: IntlShape;
  recognizeFromUrl: Function;
  callApi?: boolean;
  invoiceUrl: string;
  extractedData: any;
  isLoading: boolean;
}

export const InvoiceDocumentInfo: React.FC<invoiceDocumentInfoProps> = (
  props,
): JSX.Element => {
  useEffect(() => {
    if (props.callApi && props.recognizeFromUrl) {
      props.recognizeFromUrl(constructUrlInvoice(props.invoiceUrl));
    }
  }, [props.callApi, props.invoiceUrl]);
  return (
    <div>
      {isNil(get(props.extractedData, 'invoiceNumber', null)) &&
        props.isLoading &&
        isNil(get(props.extractedData, 'invoiceDate', null)) && (
          <WarningCardSkeleton />
        )}
      {(!isNil(get(props.extractedData, 'invoiceNumber', null)) ||
        !isNil(get(props.extractedData, 'invoiceDate', null))) && (
        <WarningCard
          message={translate(messages.extractDataTitle, props, {
            invoiceNumber: get(props.extractedData, 'invoiceNumber', '-'),
            invoiceDate: get(props.extractedData, 'invoiceDate', '-'),
          })}
        />
      )}
      {isNil(get(props.extractedData, 'invoiceNumber', null)) &&
        !props.isLoading &&
        isNil(get(props.extractedData, 'invoiceDate', null)) && (
          <WarningCard
            message={translate(messages.notExtractedDataTitle, props)}
          />
        )}
    </div>
  );
};

export default injectIntl(InvoiceDocumentInfo);
